module.exports = __webpack_public_path__ + "web/img/articles3.478254ea.png";